(() => {
  if (window.LocalizationGeoPopupInitialized) return;
  window.LocalizationGeoPopupInitialized = true;

  if (window.Shopify && window.Shopify.designMode) return;
  if (document.body && document.body.classList.contains('password')) return;
  if (window.location && /\/password(?:$|[/?#])/.test(window.location.pathname)) return;

  const popup = document.querySelector('[data-localization-geo-popup]');
  if (!popup) return;

  const STORAGE_KEY = 'rd_localization_geo_popup_v1';
  const SESSION_STORAGE_KEY = 'rd_localization_geo_popup_session_v1';
  const popupEnabled = popup.dataset.enabled !== 'false';
  if (!popupEnabled) return;

  const forceShow = popup.dataset.forceShow === 'true';
  const delayMs = Number.parseInt(popup.dataset.delayMs || '0', 10);
  const dismissDays = Number.parseInt(popup.dataset.dismissDays || '30', 10);
  const dismissMs = (Number.isFinite(dismissDays) && dismissDays > 0 ? dismissDays : 30) * 24 * 60 * 60 * 1000;

  const countrySelect = popup.querySelector('[data-geo-popup-country-select]');
  const languageSelect = popup.querySelector('[data-geo-popup-language-select]');
  const closeButtons = popup.querySelectorAll('[data-geo-popup-close]');
  const form = popup.querySelector('form');
  const submitButton = popup.querySelector('[data-geo-popup-submit]');
  const detectedRow = popup.querySelector('[data-geo-popup-detected]');
  const detectedCountryNode = popup.querySelector('[data-geo-popup-country]');
  const detectedLanguageNode = popup.querySelector('[data-geo-popup-language]');
  let activeSuggestionKey = '';
  let showTimeoutId = null;
    const syncBodyScrollLock = () => {
      document.body.classList.toggle(
        'localization-geo-popup-open',
        Boolean(document.querySelector('[data-localization-geo-popup]:not([hidden])'))
      );
  };

  const currentCountry = (popup.dataset.currentCountry || '').toUpperCase();
  const currentLanguage = (popup.dataset.currentLanguage || '').toLowerCase();

  const safeReadStorage = () => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || !parsed.expiresAt || parsed.expiresAt < Date.now()) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return parsed;
    } catch (error) {
      return null;
    }
  };

  const safeReadSessionState = () => {
    try {
      const raw = sessionStorage.getItem(SESSION_STORAGE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (error) {
      return null;
    }
  };

  const safeWriteStorage = (suggestionKey, selectionKey = '') => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          suggestionKey,
          selectionKey,
          expiresAt: Date.now() + dismissMs,
        })
      );
    } catch (error) {
      // no-op
    }
  };

  const safeWriteSessionState = (state) => {
    try {
      sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(state));
    } catch (error) {
      // no-op
    }
  };

  const getOptionByValue = (select, value, normalizeFn) => {
    if (!select || !value) return null;
    const target = normalizeFn(value);
    return Array.from(select.options).find((option) => normalizeFn(option.value) === target) || null;
  };

  const countryCodeToFlag = (countryCode) => {
    const code = String(countryCode || '')
      .trim()
      .toUpperCase();

    if (!/^[A-Z]{2}$/.test(code)) return '';

    return String.fromCodePoint(...code.split('').map((char) => 127397 + char.charCodeAt(0)));
  };

  const decorateCountryOptionsWithFlags = (select) => {
    if (!select || select.dataset.flagsDecorated === 'true') return;

    Array.from(select.options).forEach((option) => {
      const flag = countryCodeToFlag(option.value);
      if (!flag) return;

      const label = String(option.textContent || '').trim();
      if (label.startsWith(flag)) return;

      option.textContent = `${flag} ${label}`;
    });

    select.dataset.flagsDecorated = 'true';
  };

  const getSelectedCountryValue = () =>
    countrySelect ? String(countrySelect.value || '').toUpperCase() : currentCountry;

  const getSelectedLanguageValue = () =>
    languageSelect ? String(languageSelect.value || '').toLowerCase() : currentLanguage;

  const getSelectionKey = (countryValue = getSelectedCountryValue(), languageValue = getSelectedLanguageValue()) =>
    `${countryValue}|${languageValue}`;

  const persistHandledState = (action, suggestionKey = activeSuggestionKey || getSelectionKey()) => {
    const selectionKey = getSelectionKey();
    safeWriteStorage(suggestionKey, selectionKey);
    safeWriteSessionState({
      action,
      suggestionKey,
      selectionKey,
      handledAt: Date.now(),
    });
  };

  const getLanguageOptionByCountryCode = (select, countryCode) => {
    if (!select || !countryCode) return null;
    const prefix = String(countryCode).toLowerCase();
    if (!prefix) return null;

    const options = Array.from(select.options);
    return (
      options.find((option) => String(option.value || '').toLowerCase() === prefix) ||
      options.find((option) => String(option.value || '').toLowerCase().startsWith(`${prefix}-`)) ||
      null
    );
  };

  const showPopup = () => {
    if (!popup.hidden) return;
    popup.hidden = false;
    syncBodyScrollLock();
    safeWriteSessionState({
      action: 'shown',
      suggestionKey: activeSuggestionKey || getSelectionKey(),
      selectionKey: getSelectionKey(),
      handledAt: Date.now(),
    });

    window.requestAnimationFrame(() => {
      (countrySelect || languageSelect || submitButton || closeButtons[0])?.focus();
    });
  };

  const hidePopup = () => {
    if (showTimeoutId) {
      window.clearTimeout(showTimeoutId);
      showTimeoutId = null;
    }
    popup.hidden = true;
    syncBodyScrollLock();
  };

  const fetchSuggestions = async () => {
    try {
      const rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      const endpoint = `${rootPath}browsing_context_suggestions.json`;
      const response = await fetch(endpoint, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return null;
      return await response.json();
    } catch (error) {
      return null;
    }
  };

  const parseSuggestions = (payload) => {
    const detected = payload && payload.detected_values ? payload.detected_values : {};

    const suggestedCountry =
      (detected.country && (detected.country.handle || detected.country.iso_code || detected.country.code)) || '';
    const suggestedCountryName = (detected.country && (detected.country.name || detected.country.label)) || '';

    const suggestedLanguage =
      (detected.language && (detected.language.iso_code || detected.language.code || detected.language.handle)) || '';
    const suggestedLanguageName =
      (detected.language && (detected.language.endonym_name || detected.language.name || detected.language.label)) || '';

    return {
      countryCode: String(suggestedCountry || '').toUpperCase(),
      countryName: String(suggestedCountryName || ''),
      languageCode: String(suggestedLanguage || '').toLowerCase(),
      languageName: String(suggestedLanguageName || ''),
    };
  };

  decorateCountryOptionsWithFlags(countrySelect);
  syncBodyScrollLock();

  closeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      persistHandledState('dismissed');
      hidePopup();
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !popup.hidden) {
      persistHandledState('dismissed');
      hidePopup();
    }
  });

  if (form) {
    form.addEventListener('submit', () => {
      persistHandledState('submitted');
      if (submitButton) {
        submitButton.setAttribute('disabled', 'disabled');
        submitButton.setAttribute('aria-busy', 'true');
      }
      hidePopup();
    });
  }

  (async () => {
    const sessionState = safeReadSessionState();
    if (!forceShow && sessionState?.action) return;

    const stored = safeReadStorage();
    const isFirstVisit = !stored;

    const suggestionPayload = await fetchSuggestions();
    const { countryCode, countryName, languageCode, languageName } = parseSuggestions(suggestionPayload);

    const suggestedCountryOption = getOptionByValue(countrySelect, countryCode, (value) => String(value || '').toUpperCase());
    let suggestedLanguageOption = getOptionByValue(
      languageSelect,
      languageCode,
      (value) => String(value || '').toLowerCase()
    );
    const countryBasedLanguageOption = suggestedCountryOption
      ? getLanguageOptionByCountryCode(languageSelect, suggestedCountryOption.value)
      : null;

    if (!suggestedLanguageOption && countryBasedLanguageOption) {
      suggestedLanguageOption = countryBasedLanguageOption;
    }

    const hasCountrySuggestion =
      !!suggestedCountryOption &&
      String(suggestedCountryOption.value || '').toUpperCase() !== currentCountry;

    if (hasCountrySuggestion && countryBasedLanguageOption) {
      const detectedLanguageCode = suggestedLanguageOption
        ? String(suggestedLanguageOption.value || '').toLowerCase()
        : '';
      const countryLanguageCode = String(countryBasedLanguageOption.value || '').toLowerCase();

      if (!detectedLanguageCode || detectedLanguageCode === currentLanguage) {
        suggestedLanguageOption = countryBasedLanguageOption;
      }
    }

    const hasLanguageSuggestion =
      !!suggestedLanguageOption &&
      String(suggestedLanguageOption.value || '').toLowerCase() !== currentLanguage;

    if (!hasCountrySuggestion && !hasLanguageSuggestion && !forceShow && !isFirstVisit) return;

    if (hasCountrySuggestion && countrySelect) {
      countrySelect.value = suggestedCountryOption.value;
    }

    if (hasLanguageSuggestion && languageSelect) {
      languageSelect.value = suggestedLanguageOption.value;
    }

    const selectedCountryValue = countrySelect ? String(countrySelect.value || '').toUpperCase() : currentCountry;
    const selectedLanguageValue = languageSelect ? String(languageSelect.value || '').toLowerCase() : currentLanguage;
    const suggestionKey = `${selectedCountryValue}|${selectedLanguageValue}`;
    activeSuggestionKey = suggestionKey;

    if (!forceShow && stored && stored.suggestionKey === suggestionKey) return;

    if (detectedRow && detectedCountryNode && detectedLanguageNode) {
      const countryLabel = suggestedCountryOption
        ? suggestedCountryOption.textContent.split('—')[0].trim()
        : countryName || selectedCountryValue;
      const languageLabel = suggestedLanguageOption
        ? suggestedLanguageOption.textContent.trim()
        : languageName || selectedLanguageValue.toUpperCase();
      detectedCountryNode.textContent = countryLabel;
      detectedLanguageNode.textContent = languageLabel;
      detectedRow.hidden = false;
    }

    if (Number.isFinite(delayMs) && delayMs > 0) {
      showTimeoutId = window.setTimeout(() => {
        showTimeoutId = null;
        if (!forceShow && safeReadSessionState()?.action) return;
        showPopup();
      }, delayMs);
    } else {
      if (!forceShow && safeReadSessionState()?.action) return;
      showPopup();
    }
  })();
})();
